import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import pt from 'prop-types';
import styles from './Promotion.module.sass';
import Button from '../../Button/v2';
import useOption from '../../../hooks/useOption';
import { CustomerContext } from '../../../contexts/CustomerContext'
import useLocalStorage from '../../../hooks/useLocalStorage'
import OrderPackage from '../../../models/OrderPackage';
import usePoses from "../../../hooks/usePoses";
import Image from "../../Image";
import defaultBackground from "../../../assets/Package_Blue.png";
import Coupon from "../../../models/Coupon";
import routes from "../../../routes";
import classes from "../Sittings/Sittings.module.sass";
import Spinner from "../../Spinner";

export default function Promotions() {
  const history = useHistory()
  const { optionId } = useParams()
  const { customer, setCustomer } = useContext(CustomerContext);
  const { data: option, isOptionLoading } = useOption(optionId, customer.currentSchool.id);
  const packageId = option?.packageId;
  // const backgrounds = useBackgroundsFromPackage(option?.packageId)
  const [currentPromotionalCode, setCurrentPromotionalCode] = useLocalStorage(`currentPromotionalCode-${customer.currentStudent.id}`)
  const [salePrice, setSalePrice] = useState(0);
  const { data: poses } = usePoses(customer.currentStudent.id, packageId);

  const price = option?.prices && option.prices[0];
  const poseOne = poses && poses[0];
  const poseTwo = poses && poses[1];

  const usePcoupon = (packageId) => {
    const [coupon, setCoupon] = useState([]);

    useEffect(() => {
      Coupon
        .where({ packageId })
        .first()
        .then((res) => setCoupon(res.data));
    }, [packageId]);

    return coupon;
  };

  const coupon = usePcoupon(packageId);

  useEffect(() => {
    if (!coupon) return;
    if (!price) return;

    if (coupon?.value) {
      const TcouponValue = parseFloat(coupon._attributes.value, 10);
      const TpriceInt = parseFloat(price._attributes.price, 10);
      const TsalePrice = TpriceInt * (100 - TcouponValue)/100;

      setSalePrice(TsalePrice.toFixed(2));
    }
  }, [coupon, price]);

  const handleContinue = () => {
    let code = currentPromotionalCode || 1;
    setCurrentPromotionalCode(++code)
    history.push(routes.elementaryMultiPoseBuilder(packageId, { opt: option.id, step: 'build', type: 'promotion' }))
  }

  const handleDecline = () => {
    history.push(routes.review())
  }

  if (!option) return null;

  if (isOptionLoading || !(poseOne || poseTwo)) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner color="blue" />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div style={{ textAlign: 'center' }}>
          <h1 className={styles.title} style={{ marginBottom: '1rem' }}>LIMITED TIME OFFER</h1>

          <div className={styles.container}>
            <div className={styles.upperContainer}>
              <Image src={option.imageUrl.includes('missing') ? defaultBackground : option.imageUrl} alt="" classes={styles.packageImage} />
              <div className={styles.poseOne}>
                <Image src={poseOne?.watermarkUrl} alt=""/>
              </div>
              <div className={styles.poseTwo}>
                <Image src={poseTwo?.watermarkUrl} alt=""/>
              </div>
            </div>

            <div className={styles.contentWrapper}>
              <div className={styles.packageDescriptionContainer}>
                <div className={styles.innerContainer}>
                  <div>
                    <p className={styles.description}>
                      {option.name}
                    </p><br />
                    <p className={styles.description2}>
                      {option.tagline}
                    </p>
                  </div>

                  <div>
                    <p className={ (packageId == 584  || packageId == 596  || packageId == 611 || packageId == 614 || packageId == 615 || packageId == 631 || packageId == 616) && salePrice ? styles.price : styles.saleprice}>
                      {price.price ? `$${price.price.toString()}` : '$0'}
                    </p>
                    <p className={ (packageId == 584 || packageId == 596 || packageId == 611 || packageId == 614 || packageId == 615 || packageId == 631 || packageId == 616)  ? styles.saleprice : styles.salepricehidden}>

                      {salePrice ? `$${salePrice.toString()}` : ''}

                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.packageContents}>
                <p className={styles.packageText}>
                  {option.description}
                </p>
              </div>
              <Button
                className={styles.btn}
                onClick={() => handleContinue(option.id)}
              >
                Customize & Add to Cart
              </Button>
            </div>
          </div>
        </div>
        <Button className={styles.btn} variant="" onClick={handleDecline}>Continue to Checkout</Button>

      </div>
    </div>
  );
}

Promotions.propTypes = {
  onAccept: pt.func.isRequired,
  onDecline: pt.func.isRequired,
  orderPackageId: pt.oneOfType([pt.string, pt.number]).isRequired,
};
